import { render } from "./AccesoriiSelect.vue?vue&type=template&id=2a93fa36"
import script from "./AccesoriiSelect.vue?vue&type=script&lang=js"
export * from "./AccesoriiSelect.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Radu Cosmin\\Desktop\\fcfaz\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__